import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SuperAdmin } from '../models/super-admin.model';

@Injectable({ providedIn: 'root' })
export class SuperAdminService {
  private _http = inject(HttpClient);

  getSuperAdmin(): Observable<{ statusCode: number; data: SuperAdmin[] }> {
    return this._http.get<{ statusCode: number; data: SuperAdmin[] }>('/api/super-admin');
  }

  updateSuperAdmin(updatedSuperAdmin: SuperAdmin): Observable<EmptyMutationResponse> {
    return this._http.put<void>('/api/super-admin', updatedSuperAdmin, { observe: 'response' }).pipe(map(toEmptyMutationResponse));
  }

  setPassword(passwords: { currentPassword: string; newPassword: string }): Observable<EmptyMutationResponse> {
    return this._http.put<void>('/api/super-admin/set-password', passwords, { observe: 'response' }).pipe(map(toEmptyMutationResponse));
  }
}

type EmptyMutationResponse = { statusCode: number };

const toEmptyMutationResponse = (response: HttpResponse<unknown>): EmptyMutationResponse => ({ statusCode: response.status });
